module.exports = __webpack_public_path__ + "img/ct_bru-cards.9aeb3290.png";